// extracted by mini-css-extract-plugin
module.exports = {"title":"Faq_title__3-Yq4"};